__turbopack_context__.v({
  "container": "EVKzKq_container",
  "item": "EVKzKq_item",
  "itemExit": "EVKzKq_itemExit",
  "slideOut": "EVKzKq_slideOut",
  "slideUp": "EVKzKq_slideUp",
});
